module.exports = __webpack_public_path__ + "static/media/16.26283f60.jpg";